export const TASKDETAIL_LOADING = "TASKDETAIL_LOADING";
export const TASKDETAIL_RESET = "TASKDETAIL_RESET";
export const GET_TASKDETAIL = "GET_TASKDETAIL";
export const GET_TASKDETAIL_SUCCESS = "GET_TASKDETAIL_SUCCESS";
export const GET_TASKDETAIL_FAIL = "GET_TASKDETAIL_FAIL";
export const DELETE_TASKDETAIL = "DELETE_TASKDETAIL"
export const DELETE_TASKDETAIL_SUCCESS = "DELETE_TASKDETAIL_SUCCESS"
export const DELETE_TASKDETAIL_FAIL = "DELETE_TASKDETAIL_FAIL"
export const UPDATE_TASKDETAIL = "UPDATE_TASKDETAIL"
export const UPDATE_TASKDETAIL_SUCCESS = "UPDATE_TASKDETAIL_SUCCESS"
export const UPDATE_TASKDETAIL_FAIL = "UPDATE_TASKDETAIL_FAIL"
export const ADD_NEW_TASKDETAIL = "ADD_NEW_TASKDETAIL"
export const ADD_TASKDETAIL_SUCCESS = "ADD_TASKDETAIL_SUCCESS"
export const ADD_TASKDETAIL_FAIL = "ADD_TASKDETAIL_FAIL"